module.exports = __webpack_public_path__ + "static/media/solo50.8ba8ed53.JPG";